interface TextProps {
  content?: string;
  align?: 'left' | 'center' | 'right';
}

export function TextBlock({ props }: { props: TextProps }) {
  const textAlign =
    props.align === 'center' ? 'text-center' : props.align === 'right' ? 'text-right' : 'text-left';
  return (
    <div
      className={`prose prose-zinc max-w-none ${textAlign}`}
      dangerouslySetInnerHTML={{ __html: props.content ?? '' }}
    />
  );
}
